module.exports = {"Pay1":{"daobanList":[{"title":"1:您是本人还是代办人？","values":[{"name":"是本人","xuanzhong":1,"cailiaoList":[{"name":"A01057《增值税一般纳税人登记表》","state":"必要"},{"name":"市场监督管理部门核发的加载法人和组织统一社会信用代码的营业执照","state":"必要"}]},{"name":"是代办人","xuanzhong":0,"cailiaoList":[{"name":"无"}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdp-1.json
// module id = 1290
// module chunks = 0